import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
export function ImageBlock({
  block
}) {
  const {
    base64Data,
    mimeType
  } = block;
  return /*#__PURE__*/_jsx("div", {
    "data-block-type": "image",
    children: /*#__PURE__*/_jsx(Image, {
      src: `data:${mimeType};base64,${base64Data}`,
      alt: "",
      shape: "rounded",
      responsive: true,
      maxInlineSize: "100%"
    })
  });
}